var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5861 4.58606C16.9611 4.21112 17.4697 4.00049 18.0001 4.00049C18.5304 4.00049 19.039 4.21112 19.4141 4.58606L28.4141 13.5861C28.789 13.9611 28.9996 14.4697 28.9996 15.0001C28.9996 15.5304 28.789 16.039 28.4141 16.4141L19.4141 25.4141C19.0369 25.7784 18.5317 25.98 18.0073 25.9754C17.4829 25.9709 16.9812 25.7605 16.6104 25.3897C16.2396 25.0189 16.0293 24.5173 16.0247 23.9929C16.0202 23.4685 16.2217 22.9633 16.5861 22.5861L22.0001 17.0001H3.00006C2.46963 17.0001 1.96092 16.7893 1.58585 16.4143C1.21077 16.0392 1.00006 15.5305 1.00006 15.0001C1.00006 14.4696 1.21077 13.9609 1.58585 13.5858C1.96092 13.2108 2.46963 13.0001 3.00006 13.0001H22.0001L16.5861 7.41406C16.2111 7.03901 16.0005 6.53039 16.0005 6.00006C16.0005 5.46973 16.2111 4.96112 16.5861 4.58606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.f073b0f77331640014382e9ee9b95372.svg";
export { ForwardRef as ReactComponent };